var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecret = function SvgSecret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.98 69"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-miterlimit:6.67;}.cls-1,.cls-2{fill:none;stroke:var(--konflux-icon-color, #1A1A1A);stroke-width:4px;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:var(--konflux-primary-color, #FF9D76);stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.53,36.39h-5.71v-16.31c0-5.44-3.26-16.31-16.31-16.31s-16.31,10.87-16.31,16.31v16.31h-5.71c-1.35,0-2.45,1.09-2.45,2.45v27.72c0,1.35,1.1,2.45,2.45,2.45h44.03c1.35,0,2.45-1.09,2.45-2.45v-27.72c0-1.35-1.1-2.45-2.45-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.75,33h5.42c1.28,0,2.33,1.04,2.33,2.33v26.35c0,1.28-1.04,2.33-2.33,2.33H4.32c-1.28,0-2.32-1.04-2.32-2.33v-26.35c0-1.28,1.04-2.33,2.32-2.33h5.43M40.75,33v-15.5c0-5.17-3.1-15.5-15.5-15.5s-15.5,10.33-15.5,15.5v15.5M40.75,33H9.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.31,56.01c3.23,0,5.84-2.62,5.84-5.84s-2.62-5.84-5.84-5.84-5.84,2.62-5.84,5.84,2.62,5.84,5.84,5.84Z"
  }))));
};
export default SvgSecret;